import { useDispatch, useSelector } from "react-redux";
import {
    fetchingData,
    fetchDataSuccess,
    fetchDataFail,
    setCurrentPage,
    setRowsPerPage
} from './_reducers';
import { API_URL } from "../../../configs/_api";
import ApiRequest from "../../../utils/apiRequest";

const useAnalyticsReportActions = () => {
    const dispatch = useDispatch();

    const currentPage = useSelector(state => state.analyticsreport.currentPage);
    const rowsPerPage = useSelector(state => state.analyticsreport.rowsPerPage);
    
    function fetchReportList() {
        dispatch(fetchingData());
        const url = `${API_URL.Analytics}/report?page_no=${currentPage+1}&page_size=${rowsPerPage}`;
        ApiRequest.get(url)
        .then(res => {
            const data = res.data.payload.data;
            const { total_items } = res.data.payload.metadata;
            dispatch(fetchDataSuccess({data, total_items}));
        })
        .catch(err => {
            const errMsg = err.response?.data.errors.message || err.message;
            dispatch(fetchDataFail(errMsg));
        })
    }

    function changeCurrentPage(pageNo) {
        dispatch(setCurrentPage(pageNo));
    }

    function changeRowsPerPage(rowsPerPage) {
        dispatch(setCurrentPage(0));
        dispatch(setRowsPerPage(rowsPerPage));
    }

    return {
        fetchReportList,
        changeCurrentPage,
        changeRowsPerPage
    }
}

export default useAnalyticsReportActions;